export const convertImage = (imageUrl: string) => {
    // Replace the old host with the new host
    const newImageUrl = imageUrl.replace(
        "http://5.161.187.83:3000",
        String(process.env.REACT_APP_API_GRAPHQL_URL),
    );

    return newImageUrl;
};
